const sectionCode = "SPRO2";
const chartCode = "C074x";

import { Procedures } from "modules/provider/shared/procedure-charts";

function T74Procedures() {
  return <Procedures chartCode={chartCode} sectionCode={sectionCode} />;
}

export { T74Procedures };
